// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"bfc9bcb7","456":"403c1ed1"}[chunkId] + ".chunk.js";
};